var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"v-bullets":_vm.bullets,"outlined":"","hide-details":"","dense":"","rows":_vm.rows,"disabled":_vm.disabled,"value":_vm.value},on:{"input":_vm.insertBullet,"focus":_vm.insertBulletFocus}})
}
var staticRenderFns = []

export { render, staticRenderFns }